import React from 'react';

export default function GlassCard({ children, style, padding = '24px' }) {
  return (
    <div style={{
      background: 'var(--bg-card)',
      backdropFilter: 'blur(10px)',
      borderRadius: '24px',
      padding: padding,
      boxShadow: '0 8px 32px var(--bg-card-shadow)',
      border: '1px solid var(--glass-border)',
      ...style
    }}>
      {children}
    </div>
  );
}
